import dayjs from "dayjs";

export const FACILITY_REFERRAL_ERROR_MESSAGES = {
    GET_API_ERROR_MESSAGE: (apiName: string) => `Error in retrieving data from the ${apiName} API`,
    POST_API_ERROR_MESSAGE: (apiName: string) => `Error in creating ${apiName}.`,
    BLANK_ERROR_MESSAGE: (label: string) => `${label} cannot be blank.`
};

export const getFieldTitle = (
    key: string,
    formData?: Record<string, any>,
    hierarchyFormData?: Record<string, any>,
    facilityFormData?: Record<string, any>
) => {
    return formData?.[key]?.['#title']
        ?? hierarchyFormData?.[key]?.['#title']
        ?? facilityFormData?.[key]?.['#title']
        ?? key;
};

export const FACILITY_NAVIGATIONS = {
    FACILITY_REFERRAL : '/beneficiaries/facility-referral',
    FACILITY_REFERRAL_VIEW: '/beneficiaries/view/facility-referral',
    FACILITY_REFERRAL_CHILD_VIEW: '/beneficiaries/child/view/facility-referral',
}

export const FACILITY_REFERRAL_API_DETAILS = {
    REFERRED_FROM_DETAILS:'referred from details',
    REFERRAL_STATUS:'referral status',
    REFERRED_TO_DETAILS:'referred from details'
}

export const STATUS_CLASSES = {
    PENDING: 'status-pending',
    TRANSFERRED: 'status-transferred',
    REJECTED: 'status-rejected',
    MANAGED: 'status-managed',
    EXPIRED: 'status-expired',
    DEFAULT: 'status-default',
};

export const STATUS = {
    PENDING: 'Pending',
    TRANSFERRED: 'Transferred',
    REJECTED: 'Rejected',
    MANAGED: 'Managed',
    EXPIRED: 'Expired',
}

export const FACILITY_COMMON_CONSTANTS = {
    FACILITY_REFERRAL: 'Facility Referral',
    TITLE: 'Add Details/ Referral',
    MODAL_TITLE: "Do you want to close the form?",
    CHANGES_MODAL_TITLE: "You have unsaved changes. Are you sure you want to leave without saving?",
    REFER_MODAL_TITLE: 'Are you sure you want to submit this referral?',
    REFERRAL_SUCCESS: 'Beneficiary have been successfully referred.',
    REFERRAL_MANAGED:'Beneficiary have been successfully Managed.',
    REFERRAL_REJECTED:'Beneficiary have been Rejected.',
    BENEFICIARY: 'beneficiary',
    REFERRAL_DETAILS: 'Referral Details',
    USER_DETAILS: 'userDetails',
    SUBMIT: 'submit',
    CANCEL: 'Cancel',
    BACK: 'back',
    CONFIRM: 'Confirm',
    MOIC:'Medical Officer Incharge - PHC/CHC'
}

export const FACILITY_KEYS = {
    BLOCK: 'block',
    VILLAGE: 'village',
    ULB: 'ulb',
    WARD: 'ward',
    FACILITY_TYPE: 'facilityType',
    SERVICE_TYPE: 'serviceType',
    DATE_OF_VISIT: 'dateOfVisit',
    RURAL_URBAN: 'ruralUrban',
    COMMENT: 'comment',
    REASON_FOR_REFERRAL: 'reasonForReferral',
    OTHER_REASON:'otherReason',
    URBAN: 'Urban',
    RURAL: 'Rural',
    SUBDISTRICT: 'subDistrict'
}

export const FACILITY_API_DETAILS = {
    REFFERED_FOR: 'Reffered for',
    SERVICE_TYPE: 'Service type',
    REASON_FOR_REFERRAL: 'Reason for referral',
    USER_ID: 'User ID',
    ULB: 'ULB',
    DISTRICT: 'District',
    BLOCK: 'Block',
    VILLAGE: 'Village',
    WARD: 'Ward',
    RURAL_URBAN: 'Rural/Urban',
    FACILITY_TYPE: 'Facility type',
    FACILITY_FOR_REFERRAL: 'Facility for referral',
    BENEFICIARY_REFERRAL: 'Facility referral',
    REFERRAL_LIST: 'Facility referral list',
}

export const FACILITY_ERROR_MESSAGES = {
    GET_API_ERROR_MESSAGE: (apiName: string) => `Error in retrieving data from the ${apiName} API`,
    POST_API_ERROR_MESSAGE: (apiName: string) => `Error in creating ${apiName}.`,
}

export const facilityReferralState: any = {
    serviceType: {
        isError: false,
        message: "",
        isDisable: false,
        value: "",
        id: "",
    },
    reasonForReferral: {
        isError: false,
        message: "",
        isDisable: false,
        value: [],
        id: "",
    },
    otherReason:{
        isError: false,
        message: "",
        isDisable: false,
        value: "",
        id: "",
    },
    dateOfVisit: {
        isError: false,
        message: "",
        isDisable: false,
        value: "",
    },
    dateOfReferral: {
        isError: false,
        message: "",
        isDisable: false,
        value: dayjs().format("YYYY-MM-DD"),
        id: "",
    },
    timeOfReferral: {
        isError: false,
        message: "",
        isDisable: false,
        value: dayjs(),
    },
    subDistrict: {
        isError: false,
        message: "",
        isDisable: false,
        value: "",
        id: "",
    },
    ruralUrban: {
        isError: false,
        message: "",
        isDisable: false,
        value: "",
        id: "",
    },
    block: {
        isError: false,
        message: "",
        isDisable: false,
        value: "",
        id: "",
    },
    ulb: {
        isError: false,
        message: "",
        isDisable: false,
        value: "",
        id: "",
    },
    village: {
        isError: false,
        message: "",
        isDisable: false,
        value: "",
        id: "",
    },
    ward: {
        isError: false,
        message: "",
        isDisable: false,
        value: "",
        id: "",
    },
    facilityType: {
        isError: false,
        message: "",
        isDisable: false,
        value: "",
        id: "",
    },
    facilityName: {
        isError: false,
        message: "",
        isDisable: false,
        value: "",
        id: "",
    },
    comment: {
        isError: false,
        message: "",
        isDisable: false,
        value: "",
        id: "",
    },
};
     
export const facilityReferralData: any = {
    serviceType: {
        "#type": "select",
        "#title": "Service Type",
        "#webform_key": "serviceType",
        "#required": true,
        "#options": [],
    },
    reasonForReferral: {
        "#type": "select",
        '#multiDropdown':true,
        "#title": "Reason for Referral",
        "#webform_key": "reasonForReferral",
        "#required": false,
        "#options": [],
        "#isDisabled": true,
    },
    dateOfVisit: {
        "#type": "date",
        "#title": "Expected Date of visit",
        "#webform_key": "dateOfVisit",
        "#required": true,
        "#options": [],
        "#minDate": dayjs().format("YYYY-MM-DD"),
    },
    dateOfReferral: {
        "#type": "date",
        "#title": "Date of Referral",
        "#webform_key": "dateOfReferral",
        "#required": true,
        "#options": [],
        "#isDisabled": true,
    },
    timeOfReferral: {
        "#type": "time",
        "#title": "Time of Referral",
        "#webform_key": "timeOfReferral",
        "#required": true,
        "#options": [],
        "#isDisabled": true,
    },}
export const facilityReferralHierarchyData: any = {
    subDistrict: {
        "#type": "select",
        "#title": "Sub District",
        "#webform_key": "subDistrict",
        "#required": false,
        "#options": [],
    },
    ruralUrban: {
        "#type": "select",
        "#title": "Rural/Urban",
        "#webform_key": "ruralUrban",
        "#options": [],
    },
    block: {
        "#type": "select",
        "#title": "Block",
        "#webform_key": "block",
        "#options": [],
        "#isDisabled": true,
    },
    ulb: {
        "#type": "select",
        "#title": "ULB",
        "#webform_key": "ulb",
        "#options": [],
        "#isDisabled": true,
        '#showPlaceholder':true,
    },
    village: {
        "#type": "select",
        "#title": "Village",
        "#webform_key": "village",
        "#options": [],
        "#isDisabled": true,
    },
    ward: {
        "#type": "select",
        "#title": "Ward",
        "#webform_key": "ward",
        "#options": [],
        "#isDisabled": true,
    },}
export const facilityReferralFacilityData: any = {
    facilityType: {
        "#type": "select",
        "#title": "Facility Type",
        "#webform_key": "facilityType",
        "#required": true,
        "#options": [],
    },
    facilityName: {
        "#type": "select",
        "#title": "Facility Name",
        "#webform_key": "facilityName",
        "#required": true,
        "#options": [],
    },
    comment: {
        "#type": "textArea",
        "#title": "Comment",
        "#webform_key": "comment",
        "#options": [],
        "#required": false,
    },
};

export const DROPDOWN_KEYS = {
    SERVICE_TYPE: {
      VALUE: 'service_type_name',
      LABEL: 'service_type_name',
      ID: 'service_type_id',
      CODE: 'service_type_code',
    },
    SUB_DISTRICT: {
      VALUE: 'sub_district_name',
      LABEL: 'sub_district_name',
      ID: 'sub_district_id',
      CODE: 'sub_district_code',
    },
    ULB: {
      VALUE: 'ulb_name',
      LABEL: 'ulb_name',
      ID: 'ulb_id',
      CODE: 'ulb_code',
    },
    BLOCK: {
      VALUE: 'block_name',
      LABEL: 'block_name',
      ID: 'block_id',
      CODE: 'block_code',
    },
    FACILITY_TYPE: {
      VALUE: 'facility_type_name',
      LABEL: 'facility_type_name',
      ID: 'facility_type_id',
      CODE: 'facility_type_id',
    },
    RURAL_URBAN: {
      VALUE: 'urban_rural_name',
      LABEL: 'urban_rural_name',
      ID: 'urban_rural_id',
      CODE: 'urban_rural_code',
    },
    REASON_REFEERAL: {
      VALUE: 'reason_for_referral_name',
      LABEL: 'reason_for_referral_name',
      ID: 'reason_for_referral_id',
      CODE: 'reason_for_referral_code',
    },
    WARD: {
        VALUE: 'ward_name',
        LABEL: 'ward_name',
        ID: 'ward_id',
        CODE: 'ward_code',
    },
    VILLAGE: {
        VALUE: 'village_name',
        LABEL: 'village_name',
        ID: 'village_id',
        CODE: 'village_code',
    },
    FACILITY_NAME: {
        VALUE: 'facility_name',
        LABEL: 'facility_name',
        ID: 'facility_id',
        CODE: 'facility_code', 
    }
};